import { render, staticRenderFns } from "./AlarmSetting.vue?vue&type=template&id=1005aaef&scoped=true&"
import script from "./AlarmSetting.vue?vue&type=script&lang=js&"
export * from "./AlarmSetting.vue?vue&type=script&lang=js&"
import style0 from "./AlarmSetting.vue?vue&type=style&index=0&id=1005aaef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005aaef",
  null
  
)

export default component.exports